import {defineRecipe} from "@chakra-ui/react";

export const segmentGroupRecipe = defineRecipe({
    base: {
        item: {
            _before: {
                bg: "primary",
            },
            "&[data-state=checked]": {
                color: "white",
            },
        },
        indicator: {
            bg: "primary",
        },
    },
})
